<template>
  <!-- -->
</template>
<script>
	import PageComponentTemplate from '../page-component-template'

	export default {
		name: 'page-component-text',
		extends: PageComponentTemplate
	}
</script>